import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: number) => {
  return {
    staticMenu:
      userType == 3
        ? [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/home"
          },

          {
            id: 8,
            label: "Sales",
            icon: WSIcons.AllInclusiveOutlinedIcon,
            children: [

              {
                id: 4,
                label: "Contacts",
                path: "/contacts/list"
              },
              {
                id: 9,
                label: "Leads",
                path: "/leads/list"
              },

              {
                id: 147,
                label: "Users",
                path: "/user/list"
              },
              {
                id: 157,
                label: "Branch",
                path: "/branch/list"
              },
              {
                id: 142,
                label: "Roles",
                path: "/role/list"
              },
              {
                "id": 143,
                "label": "Product",
                "icon": WSIcons.TrendingUp,
                "path": "/product/list"
              },
              {
                id: 18,
                label: "Meetings",
                icon: WSIcons.ScheduleIcon,
                path: "/meeting/list"
              },
              {
                id: 200,
                label: "Report Submitted",
                path: "/reportsubmit/list"
              },
            ]
          },

          {
            id: 17,
            label: "Tasks",
            icon: WSIcons.TaskIconNew,
            path: "/task/list"
          },

          {
            id: 19,
            label: "Call",
            icon: WSIcons.CallIcon,
            path: "/call/list"
          },
          {
            id: 20,
            label: "Notes",
            icon: WSIcons.NoteIcon,
            path: "/note/list"
          },
        ]
        : [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/home"
          },

          {
            id: 8,
            label: "Sales",
            icon: WSIcons.AllInclusiveOutlinedIcon,
            children: [
              {
                id: 9,
                label: "Leads",
                path: "/leads/list"
              },
              {
                id: 4,
                label: "Contacts",
                path: "/contacts/list"
              },

              {
                id: 147,
                label: "Employee",
                path: "/employees/list"
              },
              // {
              //   id: 157,
              //   label: "Branch",
              //   path: "/branch/list"
              // },
              // {
              //   id: 142,
              //   label: "Roles",
              //   path: "/role/list"
              // },
              {
                "id": 143,
                "label": "Product",
                "icon": WSIcons.TrendingUp,
                "path": "/product/list"
              },
              {
                id: 18,
                label: "Meetings",
                icon: WSIcons.ScheduleIcon,
                path: "/meeting/list"
              },
              {
                id: 200,
                label: "Report Submitted",
                path: "/reportsubmit/list"
              },
            ]
          },

          {
            id: 17,
            label: "Tasks",
            icon: WSIcons.TaskIconNew,
            path: "/task/list"
          },

          {
            id: 19,
            label: "Call",
            icon: WSIcons.CallIcon,
            path: "/call/list",
          },
          {
            id: 20,
            label: "Notes",
            icon: WSIcons.NoteIcon,
            path: "/note/list",
          },
{
            id: 21,
            label: "Reports",
            icon: WSIcons.TrendingUp,
            path: "/reports",
          }          
        ],
  };
};
